<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">添加</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">
        <el-form :model="addForm" :rules="rules" ref="addForm">
          <div>
            <el-row>
              <el-col :span="12" class="item">
                <el-form-item label="手机号（登陆账号）" required prop="phone">
                  <el-input v-model="addForm.phone"  maxlength="11" placeholder="请输入手机号"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="item">
                <el-form-item label="登录密码" required  prop="password">
                  <el-input v-model="addForm.password" minlength="6" type="password" placeholder="请输入登录密码" show-password></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="item">
                <el-form-item label="商家名称" required prop="name">
                  <el-input v-model="addForm.name" placeholder="请输入商家名称"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="item">
                <el-form-item label="地址">
                  <el-input v-model="addForm.address" placeholder="请输入地址"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="item">
                <el-form-item label="商家类型">
                  <el-select v-model="addForm.businessType" clearable placeholder="请选择类型" style="width:100%">
                    <el-option
                        v-for="item in businessTypes"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                  </el-select>

                </el-form-item>
              </el-col>

            </el-row>
          </div>
        </el-form>
      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click.native="confirm('addForm')">确认</el-button>
      </div>
    </div>

  </div>
</template>


<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
  [{'header': 1}, {'header': 2}],               // custom button values
  [{'align': ['']},{'align': ['center']}],
  ['image'],
]

export default {
  name: 'Add',
  props: [],
  data() {
    return {

      editorOptionEdit: {
        modules: {
          toolbar: {
            container: toolbarOptions,  // 工具栏
            handlers: {
              'image': function (value) {
                if (value) {
                  //alert('自定义图片');
                  document.querySelector('.el-btn-add').click()
                } else {
                  this.quill.format('image', false);
                }
              }
            }
          }
        }
      },

      imageUrl:'',

      loading: false,

      uploadUrl:this.$shopUrl+'Upload/Imgs',
      uploadUrl1:this.$shopUrl+'Upload/File',
      uploadData:{
        staffCode:getStaffCode(),
        timeStr:timeStr,
        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey)
      },


      addForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),
        phone:'',
        password:'',
        name:'',
        address:'',
        businessType:3,
      },

      zoneList:null,
      dialogImageUrl: '',
      dialogVisible: false,

      businessTypes:[
        {value:3,label:'社区食堂商'}
      ],

      rules:{
        phone:[
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: '请输入正确的手机号'
          },
        ],
        name:[
          { required: true, message: '请输入商家名称', trigger: 'blur' },
        ],
        password:[
          { required: true, message: '请输入登录密码', trigger: 'blur' },
        ],
        address:[
          { required: true, message: '请输入地址', trigger: 'blur' },
        ],

      },

    }
  },
  methods: {
    init(){
      this.$refs.addForm.resetFields();
    },
    closeSelf() {
      this.$emit("closeAdd");
    },

    handleIdPhotoRemove(file, fileList) {
      console.log(file, fileList);
      this.addForm.idPhoto = '';
    },
    handleidPhotoSuccess(res, file) {
      console.log(file)
      this.addForm.idPhoto = this.$imgUrl+res.data.path;
    },
    handleAppendixRemove(file, fileList) {
      console.log(file, fileList);
      this.addForm.appendix = '';
    },
    handlAppendixSuccess(res, file) {
      console.log(file)
      this.addForm.appendix = this.$imgUrl+res.data.path;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleBusinessImgRemove(file, fileList) {
      console.log(file, fileList);
      this.addForm.businessImg = '';
    },
    handleBusinessImgSuccess(res, file) {
      console.log(file)
      this.addForm.businessImg = this.$imgUrl+res.data.path;
    },
    handleBusinessImgPreview(file) {
      this.businessImageUrl = file.url;
      this.businessVisible = true;
    },

    confirm(addForm){
      this.$refs[addForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          this.$message({type: 'warning', message: '请完善信息'});
          return false;
        }
      })
    },
    addSubmit(){

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Business/AddByGov",
        data: this.addForm
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error == 0) {
              this.$emit("closeAdd");
              this.$emit("getList");

            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          }
      )
    }

  }
}
</script>

<style  lang="scss" scoped>

</style>
